<template>
    <div >
      <div >
          <vx-card class="no-scroll-content" title="References" >
            <div class="vx-row">
                <div class="vx-col w-full mb-base">
                    <vs-tabs v-model="activeTab" class="tab-action-btn-fill-container" position="left" >
                        <vs-tab label="Type Of Earnings" icon-pack="feather" icon="icon-plus">
                            <div class="tab-text">
                                <earnings-type/>
                            </div>
                        </vs-tab>
                        <vs-tab label="Type Of Deductions" icon-pack="feather" icon="icon-minus">
                            <div class="tab-text">
                                <deductions-type />
                            </div>
                        </vs-tab>
                        <!-- <vs-tab label="Loans Category" icon-pack="feather" icon="icon-folder-minus">
                            <div class="tab-text">
                                <loan-category/>
                            </div>
                        </vs-tab> -->
                        <vs-tab label="Loans Sub-Category" icon-pack="feather" icon="icon-file-minus">
                            <div class="tab-text">
                                <loan-sub-category />
                            </div>
                        </vs-tab>
                    </vs-tabs>
                </div>
            </div>
          </vx-card>
      </div>
    
  </div>
    
</template>
<script>
import EarningsType from './settings/references/EarningsType.vue'
import DeductionsType  from './settings/references/DeductionsType.vue'
import LoanSubCategory  from './settings/references/LoanSubCategory.vue'
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
 export default {
    data() {
        return {
            activeTab: 0,
        }
    },
    components: {
        EarningsType,
        DeductionsType,
        LoanSubCategory,
         'v-select': vSelect,
         Datepicker,
         flatPickr,
     },
}
</script>